import { render, staticRenderFns } from "./ExtraDataSection.vue?vue&type=template&id=033a0f5a&scoped=true&"
import script from "./ExtraDataSection.vue?vue&type=script&lang=js&"
export * from "./ExtraDataSection.vue?vue&type=script&lang=js&"
import style0 from "./ExtraDataSection.vue?vue&type=style&index=0&id=033a0f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a0f5a",
  null
  
)

export default component.exports